import React, {useEffect, useState} from "react"
import {omit} from "lodash"
import id from "@irati/utils/id"
import {ValidationButton} from "@irati/ui/src/FormItem"
import Loading from "@irati/ui/src/Loading"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import useBasket from "@irati/checkout/utils/basket/useBasket"
import {OnProductSelectSubmit} from "../../../containers/DealSelectProducts"
import RLOTError from "../../DealImportantInfo/RLOTError"

interface Props extends InjectIntl {
  id?: string,
  disabled?: boolean,
  onClick: OnProductSelectSubmit,
  isPay?: boolean
}

const Continue: React.FC<Props> = (props) => {
  const basket = useBasket()
  const [submit, setSubmit] = useState(Promise.resolve())

  useEffect(() => {
    setSubmit(Promise.resolve())
  }, [JSON.stringify(basket.items.map((item) => omit(item, "targetUserId")))])

  const handleClick = () => {
    setSubmit(props.onClick())
  }

  const {isPay, formatMessage, disabled} = props
  return (
    <>
      <Loading load={submit} useLoader={false} Error={RLOTError} />
      <ValidationButton
        id={id("continue", props, {force: true})}
        primary
        large
        full
        load={submit}
        disabled={disabled}
        onClick={handleClick}>
        {formatMessage({id: isPay ? "perks.containers.paymentOrder.paymentOption.buttonText" : "perks.continueButton.continue"})}
      </ValidationButton>
    </>
  )
}

export default injectIntl(Continue)
